import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { SettingsState } from './types';

export const defaultSettingsState: SettingsState = {
  isFormDirty: false
};

export default function reducer(state: SettingsState = defaultSettingsState, action: Actions): SettingsState {
  switch (action.type) {
    case ActionTypes.SET_IS_FORM_DIRTY:
      return { ...state, isFormDirty: action.payload };
    default:
      return state;
  }
}
